import React from "react";
import {
  Workspaces,
  Badge,
  Payments,
  DateRange,
  PunchClock,
  FilterTiltShift,
  Timer,
  AccessTime,
  Paid,
  ViewWeek,
  Update,
  CardGiftcard,
  HourglassBottom,
  HistoryToggleOff,
  MilitaryTech,
  Bolt,
  Functions,
  AccountCircle,
  People,
  SportsBaseball,
  PermIdentity,
  RemoveCircleOutline,
  MonetizationOn,
  AddCard,
  Source,
  AccountBalance,
  PeopleAlt,
} from "@mui/icons-material";

export const earningHeaders = [
  {
    header: "Name",
    key: "name",
  },
  {
    header: "Action",
    key: "action",
  },
];

export const payScheduleKeyPair = [
  {
    key: "name",
    name: "Payrun name",
  },
  {
    key: "start_date",
    name: "Start date",
  },
  {
    key: "end_date",
    name: "End date",
  },
  {
    key: "num_of_employees",
    name: "Number of Employee",
  },
  {
    key: "run_date",
    name: "Pay date",
  },
  {
    key: "group_count",
    name: "Group count",
  },
  {
    key: "action",
    name: "Action",
  },
];

export const deductionHeaders = [
  { header: "Name", key: "name" },
  { header: "Deduction Type", key: "deduction_type_display" },
  { header: "Action", key: "action" },
];

export const ComponentTypeDetails = [
  {
    label: "Earnings",
  },
  {
    label: "Deduction",
  },
  {
    label: "Expense",
  },
];

export const overTime = [
  {
    label: "Hour",
  },
  {
    label: "Day",
  },
];

export const PayRollEmployeeHeader = [
  {
    header: "Employee Name",
    key: "employee name",
  },
  {
    header: "Employee Id",
    key: "employeeid",
  },
  {
    header: "Cost to company (per year)",
    key: "",
  },
  {
    header: "Payroll Group",
    key: "payroll_group",
  },
  {
    header: "Status",
    key: "status",
  },
  {
    header: "Action",
    key: "",
  },
];

export const PaymentMode = [
  {
    label: "NEFT",
  },
  {
    label: "Cash",
  },
  {
    label: "Cheque",
  },
];

export const summaryDetails = [
  {
    label: "Cost Structure",
  },
  {
    label: "Attendance Timeline",
  },
  // {
  //   label: "Over Time",
  // },
  // {
  //   label: "Salary Revision",
  // },
];

export const salaryRevisionKeyPair = [
  {
    name: "Employee Name",
  },
  {
    name: "Employee Id",
  },
  {
    name: "Old CTC",
  },
  {
    name: "Revised CTC",
  },
  {
    name: "Revision Month",
  },
];

export const overTimeKeyPair = [
  {
    name: "Action",
  },
  {
    name: "Employee Name",
  },
  {
    name: "Employee Id",
  },
  {
    name: "Overtime Hours",
  },
  {
    name: "Per Hour Rate",
  },
  {
    name: "Total Amount",
  },
];

export const salaryStatementReportPart1 = [
  {
    name: "Employee Name",
    key: "user_name",
  },
  {
    name: "Employee ID",
    key: "employee_id",
  },
  {
    name: "Monthly CTC",
    key: "monthly_ctc",
  },
  {
    name: "Mode of payment",
    key: "mode_of_payment",
  },
  {
    name: "Per hour salary",
    key: "per_hour_salary",
  },
  {
    name: "Per day salary",
    key: "per_day_salary",
  },
  {
    name: "Payable Days",
    key: "paid_days",
  },
  {
    name: "Shift Duration",
    key: "shift_duration",
  },
  {
    name: "Hours",
    key: "total_hours",
  },
  {
    name: "LOP",
    key: "lop",
  },
  {
    name: "LOP Amount",
    key: "lop_amount",
  },
  {
    name: "Gross",
    key: "gross_pay",
  },
];

export const salaryStatementReportPart2 = [
  {
    name: "Total Deductions",
    key: "total_deductions",
  },
  {
    name: "Net Pay",
    key: "net_pay",
  },
  {
    name: "Department",
    key: "department",
  },
  {
    name: "Bank",
    key: "bank",
  },
];

export const ESIReportKeys = [
  {
    name: "Employee Name",
    key: "user_name",
  },
  {
    name: "Employee ID",
    key: "employee_id",
  },
  {
    name: "ESI No",
    key: "esi_no",
  },
  {
    name: "Gross salaray",
    key: "gross_pay",
  },
  {
    name: "Per day salary",
    key: "per_day_salary",
  },
  {
    name: "Number of days in ESI",
    key: "paid_days",
  },
  {
    name: "Employee contribution",
    key: "employee_esi",
  },
  {
    name: "Company contribution",
    key: "company_esi",
  },
  {
    name: "Total esi amount",
    key: "total_esi",
  },
];

export const EPFReportKeys = [
  {
    name: "Employee Name",
    key: "user_name",
  },
  {
    name: "Employee ID",
    key: "employee_id",
  },
  {
    name: "PF No",
    key: "pf_no",
  },
  {
    name: "Employee Contribution",
    key: "employee_pf",
  },
  {
    name: "Company Contribution",
    key: "employer_pf",
  },
  {
    name: "Total Contribution",
    key: "total_contribution",
  },
];

export const IncentiveHeader = [
  {
    name: "Incentive Name",
    key: "name",
  },
  {
    name: "Incentive Type",
    key: "incentive_type",
  },
  {
    name: "Calculation Mode",
    key: "calculation_mode",
  },
  {
    name: "Status",
    key: "status",
  },
  {
    name: "Actions",
    key: "actions",
  },
];

export const incentiveMode = [
  { label: "fixed" },
  // { label: "percentage" },
  // { label: "unit" },
];

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const payCycle = [
  {
    id: 1,
    label: "Weekly",
  },
  {
    id: 2,
    label: "Bi-Weekly",
  },
  {
    id: 3,
    label: "Monthly",
  },
  // {
  //   id: 4,
  //   label: "Bi-Monthly",
  // },
  {
    id: 4,
    label: "Semi-Monthly",
  },
  {
    id: 5,
    label: "Custom",
  },
];

export const weekDays = [
  { label: "Monday" },
  { label: "Tuesday" },
  { label: "Wednesday" },
  { label: "Thursday" },
  { label: "Friday" },
  { label: "Saturday" },
  { label: "Sunday" },
];

export const days_of_week2 = [
  { label: "Sunday" },
  { label: "Monday" },
  { label: "Tuesday" },
  { label: "Wednesday" },
  { label: "Thursday" },
  { label: "Friday" },
  { label: "Saturday" },
];

export const GroupEmployee = [
  {
    name: "Employee name",
    key: "employee_name",
  },
  {
    name: "Employee id",
    key: "employee_id",
  },
  {
    name: "Paid days",
    key: "paid_days",
  },
  {
    name: "Grosses Pay",
    key: "gross_pay",
  },
  {
    name: "Deduction",
    key: "deduction",
  },
  {
    name: "Net Salary",
    key: "net_salary",
  },
  {
    name: "Add. Deduction",
    key: "additional_deduction",
  },
  {
    name: "Net Pay",
    key: "net_pay",
  },
];

export const payRunTableHeader = [
  {
    name: "Payrun Name",
    key: "name",
  },
  {
    name: "Start Date",
    key: "start_date",
  },
  {
    name: "End Date",
    key: "end_date",
  },
  {
    name: "Number of Employee",
    key: "num_of_employees",
  },
  {
    name: "Pay Date",
    key: "run_date",
  },
  {
    name: "Group count",
    key: "group_count",
  },
  {
    name: "Status",
    key: "status",
  },
];

export const payrunCycleTableFilterKeys = [
  "pay_run_cycle_type",
  "date_of_month",
  "day_of_week",
  "payment_basis",
  "name",
];

export const EmployeeBankDetailsHeader = [
  {
    name: "Employee",
    key: "user_name",
  },
  {
    name: "EmployeeId",
    key: "employee_id",
  },
  {
    name: "Account Holder Name",
    key: "account_holder_name",
  },
  {
    name: "Account No",
    key: "account_no",
  },
  {
    name: "Bank Name",
    key: "bank_name",
  },
  {
    name: "Bank Branch",
    key: "branch_name",
  },
  {
    name: "IFSC",
    key: "ifsc",
  },
  {
    name: "Amount",
    key: "net_pay",
  },
];

export const incentiveType = [
  {
    label: "Attendance",
  },
  {
    label: "OverTime",
  },
  {
    label: "Custom",
  },
];

export const IncentiveEmployeeDetails = [
  {
    name: "Employee Name",
    key: "employee_name",
  },
  {
    name: "Type",
    key: "incentive_type",
  },
  {
    name: "Date Range",
    key: "{start_date}-{end_date}",
  },
  {
    name: "Amount",
    key: "incentive_amount",
  },
  {
    name: "Status",
    key: "status",
  },
  {
    name: "Payrun",
    key: "payrun_month",
  },
  {
    name: "Action",
    key: "action",
  },
];

// updated design

export const earningShiftHeader = [
  {
    name: "Date",
    key: "date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    name: "Emp ID",
    key: "employee_code",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Emp Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Day Type",
    key: "earning_type",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
  {
    name: "Shift",
    key: "shift_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Working Hrs",
    key: "worked_shift_hours",
    type: "time",
    icon: <Timer fontSize="small" />,
    showBetweenOperator: false,
  },

  {
    name: "Basis",
    key: "basis",
    type: "autocomplete",
    icon: <HistoryToggleOff fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Credited Qty",
    key: "quantity",
    type: "number",
    icon: <FilterTiltShift fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Penalty Qty",
    key: "penalty",
    type: "number",
    icon: <CardGiftcard fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Net",
    key: "net",
    type: "number",
    icon: <Payments fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Factor",
    key: "payment_factor",
    type: "number",
    icon: <Bolt fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Payable",
    key: "adjusted",
    type: "number",
    icon: <Badge fontSize="small" />,
    showBetweenOperator: false,
  },
];

export const earningOvertimeHeader = [
  {
    name: "Date",
    key: "date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    name: "Emp ID",
    key: "employee_code",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Emp Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Type",
    key: "ot_consideration_type",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
  {
    name: "Worked Hrs",
    key: "ot_working_hours",
    type: "time",
    icon: <Timer fontSize="small" />,
    showBetweenOperator: false,
  },

  {
    name: "Basis",
    key: "based_on",
    type: "autocomplete",
    icon: <HistoryToggleOff fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Qty",
    key: "final_approved_ot",
    type: "number",
    icon: <FilterTiltShift fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <CardGiftcard fontSize="small" />,
    showBetweenOperator: false,
  },
];

export const deductionsPenaltiesHeader = [
  {
    name: "Date",
    key: "date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    name: "Emp ID",
    key: "employee_code",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Emp Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Penalty type",
    key: "penalty_type",
    type: "autocomplete",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Deviation Duration",
    key: "deficit_hrs",
    type: "time",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Penalty Basis",
    key: "basis",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Penalty",
    key: "penalty",
    type: "number",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Adjustment Basis",
    key: "adjuted_basis",
    type: "number",
    icon: <Update fontSize="small" />,
  },
  {
    name: "Adjusted Qty",
    key: "adjusted",
    type: "number",
    icon: <Paid fontSize="small" />,
  },
];

export const dailyPayrunHeaders = [
  { name: "Date", key: "date" },
  { name: "Emp ID", key: "employee_code" },
  { name: "Emp Name", key: "employee_name" },
  { name: "Day Type", key: "day_type" },
  {
    name: "Regular Pay",
    children: [
      { name: "Pay Basis", key: "earning_basis" },
      { name: "Worked Qty", key: "earning_qty" },
      { name: "Rate", key: "earning_rate" },
      { name: "Amount", key: "earning_amount" },
    ],
  },
  {
    name: "Overtime",
    children: [
      { name: "OT Basis", key: "ot_basis" },
      { name: "OT Qty", key: "ot_qty" },
      { name: "Rate", key: "ot_rate" },
      { name: "Amount", key: "ot_amount" },
    ],
  },
  { name: "Total", key: "net_salary" },
];

export const operationsDailyPayrunHeader = [
  {
    name: "Date",
    key: "date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    name: "Emp Id",
    key: "employee_code",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Emp Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Day type",
    key: "day_type",
    type: "autocomplete",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Pay basis",
    key: "earning_basis",
    type: "autocomplete",
    icon: <FilterTiltShift fontSize="small" />,
  },
  {
    name: "Worked Qty",
    key: "earning_qty",
    type: "number",
    icon: <PunchClock fontSize="small" />,
  },
  {
    name: "Rate",
    key: "earning_rate",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Amount",
    key: "earning_amount",
    type: "number",
    icon: <Paid fontSize="small" />,
  },
  {
    name: "OT Basis",
    key: "ot_basis",
    type: "number",
    icon: <Update fontSize="small" />,
  },
  {
    name: "OT Qty",
    key: "ot_qty",
    type: "number",
    icon: <HourglassBottom fontSize="small" />,
  },
  {
    name: "Amount",
    key: "ot_amount",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Total",
    key: "net_salary",
    type: "number",
    icon: <Functions fontSize="small" />,
  },
];

export const payrunCycleHeader = [
  {
    name: "Pay Cycle",
    key: "pay_run_cycle_type",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Start Day",
    key: "start_day",
    type: "string",
    icon: <Workspaces fontSize="small" />,
    customFormatter: (item) => {
      return item?.pay_run_cycle_type === "Monthly"
        ? (item?.date_of_month ?? "N/A")
        : (item?.start_day ?? "N/A");
    },
  },
  {
    name: "Starts On",
    key: "start_date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "start_date",
      toField: "start_date",
    },
  },

  {
    name: "Next Run Date",
    key: "next_pay_run_date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "next_pay_run_date",
      toField: "next_pay_run_date",
    },
  },
  {
    name: "Calc based on",
    key: "payment_basis",
    type: "autocomplete",
    icon: <Payments fontSize="small" />,
  },

  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <MilitaryTech fontSize="small" />,
  },

  {
    name: "Payrun Cycle Name",
    key: "name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
];

export const PaycycleHistoryHeader = [
  {
    name: "Payrun Name",
    key: "pay_run_cycle_name",
  },
  {
    name: "Start Date",
    key: "start_date",
  },
  {
    name: "End Date",
    key: "end_date",
  },
  {
    name: "Group Count",
    key: "group_count",
  },
  {
    name: "No of Employees",
    key: "no_of_employees",
  },
  {
    name: "Status",
    key: "status",
  },
];

export const paymentBankHeader = [
  {
    name: "Bank Name",
    key: "bank_name",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Nick Name",
    key: "nick_name",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Account Number",
    key: "bank_account_number",
    type: "number",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Branch",
    key: "bank_branch",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "IFSC Code",
    key: "bank_ifsc_code",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
];

export const payrollGroupHeader = [
  {
    name: "Payroll Group Name",
    key: "name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Payrun Cycle",
    key: "pay_run_cycle_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Payment Bank",
    key: "source_bank_detail_name",
    type: "autocomplete",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Payment Mode",
    key: "mode_of_payment",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Employee Count",
    key: "users_count",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
];

export const payrollCycleHeader = [
  {
    name: "Payrun name",
    key: "name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Start date",
    key: "start_date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "start_date",
      toField: "end_date",
    },
  },
  {
    name: "End date",
    key: "end_date",
    type: "autocomplete",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "start_date",
      toField: "end_date",
    },
  },
  {
    name: "No of employee",
    key: "no_of_employees",
    type: "number",
    icon: <AccountCircle fontSize="small" />,
  },
  {
    name: "Pay date",
    key: "run_date",
    type: "number",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "run_date",
      toField: "run_date",
    },
  },
  {
    name: "Group Count",
    key: "group_count",
    type: "number",
    icon: <People fontSize="small" />,
  },
  {
    name: "Basis",
    key: "payment_basis",
    type: "autocomplete",
    icon: <SportsBaseball fontSize="small" />,
  },
  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <MilitaryTech fontSize="small" />,
  },
];

export const upcomingPayrollCycleHeader = [
  {
    name: "Payrun name",
    key: "name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Start date",
    key: "start_date",
    type: "date",
    icon: <Workspaces fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "start_date",
      toField: "end_date",
    },
  },
  {
    name: "End date",
    key: "end_date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "start_date",
      toField: "end_date",
    },
  },
  {
    name: "No of employee",
    key: "no_of_employees",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Pay date",
    key: "run_date",
    type: "date",
    icon: <Badge fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "run_date",
      toField: "run_date",
    },
  },
  {
    name: "Group Count",
    key: "group_count",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Basis",
    key: "payment_basis",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
];

export const payrunEmployeeHeader = [
  {
    name: "Employee Name",
    key: "employee_name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Employee Id",
    key: "employee_id",
    type: "string",
    icon: <PermIdentity fontSize="small" />,
  },
  {
    name: "Gross Pay",
    key: "gross_pay",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Deduction",
    key: "deduction",
    type: "number",
    icon: <RemoveCircleOutline fontSize="small" />,
  },
  {
    name: "Net Salary",
    key: "net_salary",
    type: "number",
    icon: <MonetizationOn fontSize="small" />,
  },
  {
    name: "Add. Deduction",
    key: "additional_deduction",
    type: "number",
    icon: <RemoveCircleOutline fontSize="small" />,
  },
  {
    name: "Net Pay",
    key: "net_pay",
    type: "number",
    icon: <Paid fontSize="small" />,
  },
  {
    name: "Action",
    key: "Action",
  },
];

export const runPayrollGroupHeaders = [
  {
    name: "Group name",
    key: "name",
    type: "string",
    icon: <PeopleAlt fontSize="small" />,
  },
  {
    name: "No. of Emp",
    key: "no_of_employee",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Payment Bank",
    key: "payment_bank",
    type: "autocomplete",
    icon: <AccountBalance fontSize="small" />,
  },
  {
    name: "Payment Mode",
    key: "payment_mode",
    type: "autocomplete",
    icon: <Source fontSize="small" />,
  },
  {
    name: "Payroll cost",
    key: "payroll_cost",
    type: "number",
    icon: <AddCard fontSize="small" />,
  },
  {
    name: "Total Deduction",
    key: "total_deduction",
    type: "number",
    icon: <RemoveCircleOutline fontSize="small" />,
  },
  {
    name: "Group net salary",
    key: "group_net_salary",
    type: "number",
    icon: <MonetizationOn fontSize="small" />,
  },
  {
    name: "Additional deduction",
    key: "additional_deduction",
    type: "number",
    icon: <RemoveCircleOutline fontSize="small" />,
  },
  {
    name: "Net pay",
    key: "net_pay",
    type: "number",
    icon: <Paid fontSize="small" />,
  },
  {
    name: "Action",
    key: "Action",
  },
];

export const payrollGroupEmployeeHeader = [
  {
    name: "Employee Id",
    key: "employee_id",
  },
  {
    name: "Employee Name",
    key: "username",
  },

  {
    name: "Action",
    key: "action",
  },
];

export const paymentOptions = [
  {
    id: "Shift",
    label: "Shift",
    description:
      "Calculate pay based on the number of adjusted shifts during the payroll period",
  },
  {
    id: "Hours",
    label: "Hours",
    description:
      "Calculate pay based on the total adjusted working hours in the payroll period",
  },
];

export const earningTypeColors = {
  "Shift Earning": { bg: "#1abc9c", color: "#fff" },
  "Paid Week Off": { bg: "#d35400", color: "#fff" },
  "Paid Leave": { bg: "#9b59b6", color: "#fff" },
  "Company Leave Attendance": { bg: "#9b59b6", color: "#fff" },
  "Paid Company Leave": { bg: "#D1D16B", color: "#000" },
  Holilday: { bg: "#4c9d97", color: "#fff" },
  Absent: { bg: "#ff6666", color: "#fff" },
};

export const penaltyTypeColors = {
  "Absent Deductions": { bg: "#1abc9c", color: "#fff" },
  "Late Early": { bg: "#d35400", color: "#fff" },
  "Early Exit": { bg: "#9b59b6", color: "#fff" },
  "Break Penalty": { bg: "#9b59b6", color: "#fff" },
  Absent: { bg: "#ff6666", color: "#fff" },
};

export const dailyPayrunColors = {
  Holilday: { bg: "#4c9d97", color: "#fff" },
  "Break penality": { bg: "#ddbbd4", color: "#fff" },
  "Week Day": { bg: "#88D8B3", color: "#000" },
  "Weekoff Attendance": { bg: "#a7bfec", color: "#000" },
  Absent: { bg: "#ff6666", color: "#fff" },
  "Paid Company Leave": { bg: "#D1D16B", color: "#000" },
};

export const weekDaysName = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const legendData = [
  { label: "Present", code: "P", color: "#3A8D4C" },
  { label: "Absent", code: "A", color: "#DE4646" },
  { label: "Shift Planned", code: "SP", color: "#F675FF" },
  { label: "Unassigned", code: "UA", color: "#87CEEB" },
  { label: "Late Entry", code: "LE", color: "#DBA6FFD5" },
  { label: "Early Exit", code: "EE", color: "#E1FF77AC" },
  { label: "Overtime", code: "OT", color: "#F5E9E8" },
  { label: "Missing", code: "M", color: "#FF9169" },
  { label: "Week Off", code: "W", color: "#D3FCFC" },
  { label: "Permission", code: "PR", color: "#171D1A" },
  { label: "Leave", code: "L", color: "#D3A500" },
  { label: "Half Day Leave", code: "HL", color: "#6B3E3E" },
  { label: "Holiday", code: "H", color: "#9D97FAFF" },
  { label: "Not Joined", code: "NJ", color: "#808080" },
];

export const DailyPayrunAmountDateView = [
  { name: "", key: "" },
  { name: "Date", key: "date" },
  {
    name: "Regular Pay",
    children: [
      { name: "No of Employee", key: "shift_no_employee" },
      { name: "Amount", key: "earning_amount" },
    ],
  },
  {
    name: "Overtime",
    children: [
      { name: "No of Employee", key: "ot_no_employee" },
      { name: "Amount", key: "ot_amount" },
    ],
  },
  { name: "Total", key: "total_amount" },
];

export const expandHearder = [
  { name: "Date", key: "date" },
  { name: "Payschedule", key: "payschedule_name" },
  { name: "PayCycleEmployee", key: "no_cycle_employee" },
  { name: "DailyPayrunEmployee", key: "no_daily_payrun" },
  {
    name: "Regular Pay",
    children: [
      { name: "No of Employee", key: "shift_no_employee" },
      { name: "Amount", key: "earning_amount" },
    ],
  },
  {
    name: "Overtime",
    children: [
      { name: "No of Employee", key: "ot_no_employee" },
      { name: "Amount", key: "ot_amount" },
    ],
  },
  { name: "Total", key: "total_amount" },
];
